export const columns = [
  {
    Header: 'Titulo',
    accessor: 'title',
  },
  {
    Header: 'Nav',
    accessor: 'nav',
  },
  {
    Header: 'Imagen',
    accessor: 'image',
  },
  {
    Header: 'Enlace',
    accessor: 'url',
  },
  {
    Header: 'Editar',
    accessor: 'editDrawer',
  },
  {
    Header: 'Eliminar',
    accessor: 'deleteDrawer',
  },
  {
    Header: 'Estado',
    accessor: 'active',
  },
]

export const data = [
  {
    title: 'Titulo 1',
    content: 'Contenido 1',
    image: 'https://via.placeholder.com/150',
    link: 'https://via.placeholder.com/150',
  },
  {
    title: 'Titulo 2',
    content: 'Contenido 2',
    image: 'https://via.placeholder.com/150',
    link: 'https://via.placeholder.com/150',
  },
  {
    title: 'Titulo 3',
    content: 'Contenido 3',
    image: 'https://via.placeholder.com/150',
    link: 'https://via.placeholder.com/150',
  },
]
